import { registerPlugin } from '@capacitor/core';
const VolumeControl = registerPlugin('VolumeControl', {
    web: () => import('./web').then(m => new m.VolumeControlWeb()),
});
export * from './definitions';
export { VolumeControl };
